<template>
  <div class="notice">
    <v-header></v-header>
    <div class="content_main">
      <div class="content">
        <!-- 2021-6-3 -->
        <div class="part" v-for="item in noticeData" :key="item.noticeId">
          <h3 class="ql-size-huge">公告</h3>
          <div class="content_text follow" @click="notice(item.noticeTitle, item.noticeContent)">{{ item.noticeTitle }}
          </div>
        </div>
      </div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageInt.pageNum" :page-size="pageInt.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 50, 100, 200]" :total="pageInt.total">
        </el-pagination>
      </div>
      <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible" width="750px">
        <div v-html="noticeContent" class="ql-editor"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { allNotice } from '../../module/api'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  name: 'notice',
  data() {
    return {
      noticeData: [],
      dialogTableVisible: false,
      dialogTitle: '',
      noticeContent: '',
      pageInt: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.getNotice()
  },
  methods: {
    getNotice() {
      allNotice({ pageNum: this.pageInt.pageNum, pageSize: this.pageInt.pageSize }).then(res => {
        if (res.data.code == 200) {
          let { rows, pageNum, pageSize, total } = res.data
          this.noticeData = rows;
          this.pageInt = { pageNum, pageSize, total }
        }
      })
    },
    notice(title, content) {
      this.dialogTitle = title
      this.noticeContent = content
      this.dialogTableVisible = true;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageInt.pageSize = val
      this.getNotice()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageInt.pageNum = val
      this.getNotice()
    }
  },

}
</script>

<style scoped>
.ql-editor {
  font-size: 14px;
  line-height: 1.75;

}

.ql-editor img {
  max-width: 100%;
}

.notice {
  width: 100%;
  height: auto;
  background: #f2f7ff;
  box-sizing: border-box;
  user-select: text;
}

.notice .content_main {
  width: 1200px;
  margin: auto;
  background: #ffffff;
  padding: 0 40px 30px;
  box-sizing: border-box;
}

.content {
  overflow: hidden;
  margin-top: 20px;
}

.content .part {
  margin: 20px 0;
  color: #333333;
  font-family: MicrosoftYaHei;
  font-size: 15px;
  line-height: 23px;
  letter-spacing: 1px;
  word-break: break-all;
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e5e5;
}

.content .part:last-child {
  border-bottom: none;
}

.content .part.contact {
  margin-top: 10px;
}

.part h3 {
  font-size: 18px;
  font-weight: normal;
  color: rgb(158, 159, 159);
  margin: 8px 0;
}

.part h3::before {
  content: "";
  display: inline-block;
  width: 44px;
  height: 38px;
  background: url(./image/TVLogo.png) no-repeat;
  background-size: 100% 100%;
  vertical-align: middle;
  margin-right: 7px;
  margin-left: 6px;
}

.part .content_text {
  text-indent: 55px;
  line-height: 26px;
}

.part .follow {
  cursor: pointer;
}

.part .content_text .iden {
  color: #000000;
  font-size: 16px;
}

.part h4 {
  text-indent: 2em;
  color: #000000;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 2px;
}

.paging {
  /* float: right; */
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/recruit/notice.vue